var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", [_vm._v("Social Medias")]),
    _vm._v(" "),
    _c("p", [_vm._v("Please enter relevant social media accounts.")]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          staticClass: "form-group col-md-11 input-group",
          staticStyle: { margin: "20px" }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.facebook,
                expression: "facebook"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "url" },
            domProps: { value: _vm.facebook },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.facebook = $event.target.value
              }
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form-group col-md-11 input-group",
          staticStyle: { margin: "20px" }
        },
        [
          _vm._m(1),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.twitter,
                expression: "twitter"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "url" },
            domProps: { value: _vm.twitter },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.twitter = $event.target.value
              }
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form-group col-md-11 input-group",
          staticStyle: { margin: "20px" }
        },
        [
          _vm._m(2),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.linkedIn,
                expression: "linkedIn"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "url" },
            domProps: { value: _vm.linkedIn },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.linkedIn = $event.target.value
              }
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form-group col-md-11 input-group",
          staticStyle: { margin: "20px" }
        },
        [
          _vm._m(3),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.instagram,
                expression: "instagram"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "url" },
            domProps: { value: _vm.instagram },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.instagram = $event.target.value
              }
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form-group col-md-11 input-group",
          staticStyle: { margin: "20px" }
        },
        [
          _vm._m(4),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.googlePlus,
                expression: "googlePlus"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "url" },
            domProps: { value: _vm.googlePlus },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.googlePlus = $event.target.value
              }
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form-group col-md-11 input-group",
          staticStyle: { margin: "20px" }
        },
        [
          _vm._m(5),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.weChat,
                expression: "weChat"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "url" },
            domProps: { value: _vm.weChat },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.weChat = $event.target.value
              }
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form-group col-md-11 input-group",
          staticStyle: { margin: "20px" }
        },
        [
          _vm._m(6),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.angelList,
                expression: "angelList"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "url" },
            domProps: { value: _vm.angelList },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.angelList = $event.target.value
              }
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form-group col-md-11 input-group",
          staticStyle: { margin: "20px" }
        },
        [
          _vm._m(7),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.crunchBase,
                expression: "crunchBase"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "url" },
            domProps: { value: _vm.crunchBase },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.crunchBase = $event.target.value
              }
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form-group col-md-11 input-group",
          staticStyle: { margin: "20px" }
        },
        [
          _vm._m(8),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.youTube,
                expression: "youTube"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "url" },
            domProps: { value: _vm.youTube },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.youTube = $event.target.value
              }
            }
          })
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white", width: "110px" }
      },
      [_c("span", [_vm._v("Facebook")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white", width: "110px" }
      },
      [_c("span", [_vm._v("Twitter")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white", width: "110px" }
      },
      [_c("span", [_vm._v("LinkedIn")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white", width: "110px" }
      },
      [_c("span", [_vm._v("Instagram")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white", width: "110px" }
      },
      [_c("span", [_vm._v("Google+")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white", width: "110px" }
      },
      [_c("span", [_vm._v("WeChat")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white", width: "110px" }
      },
      [_c("span", [_vm._v("AngelList")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white", width: "110px" }
      },
      [_c("span", [_vm._v("CrunchBase")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white", width: "110px" }
      },
      [_c("span", [_vm._v("YouTube")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-201e0190", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-201e0190","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/elements/socialMedia.vue
// module id = 181
// module chunks = 0